export default __webpack_public_path__ + "5508b0e6be2fe2106d80428f472cc5fb.png";